import { API_BASE_URL } from '../config/api';

export const checkApiConnection = async () => {
    try {
        const response = await fetch(`${API_BASE_URL}/api/posts/`);
        if (response.ok) {
            console.log('✅ Conexión API exitosa');
            return true;
        } else {
            console.error('❌ Error en conexión API:', response.status);
            return false;
        }
    } catch (error) {
        console.error('❌ Error de conexión API:', error);
        return false;
    }
};